import React, { Suspense, useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '../node_modules/font-awesome/css/font-awesome.min.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'core-js';
import 'whatwg-fetch';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { themeCharcoalBlue, themeMaroonish } from 'theme/theme';
import Storages from 'storages';
import StorageKeys from 'enum/storages.enum';
import { Theme } from 'enum/design';
import EventBus from 'utils/eventBus';

const getTheme = () => {
  const theme = Storages.MainStorage.getItem(StorageKeys.Keys.ACTIVETHEME);
  if (theme === Theme.Maroon) {
    return themeMaroonish;
  }
  return themeCharcoalBlue;
};

const loadingMarkup = (
  <div className='py-4 text-center'>
    <h3>Loading..</h3>
  </div>
);

const AppWrapper = () => {
  const [currentTheme, setCurrentTheme] = useState(getTheme());

  useEffect(() => {
    const refreshSub = EventBus.subscribe('refresh', () => {
      setCurrentTheme(getTheme());
    });

    return () => {
      refreshSub.unsubscribe();
    };
  }, []);

  return (
    <Suspense fallback={loadingMarkup}>
      {/* <React.StrictMode> */}
      <BrowserRouter>
        <ThemeProvider theme={currentTheme}>
          <App />
        </ThemeProvider>
      </BrowserRouter>
      {/* </React.StrictMode> */}
    </Suspense>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<AppWrapper />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
